import { render } from "./DataTracking.vue?vue&type=template&id=f23a0d50"
import script from "./DataTracking.vue?vue&type=script&lang=js"
export * from "./DataTracking.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__